export const ADMIN = "Admin";
export const FACULTY = "Faculty";
export const DEPARTMENT = "Department";
export const EDUCATIONAL_DEPARTMENT = "EducationalDepartment";